module.exports = __webpack_public_path__ + "static/img/jchb1-8.aa0640a.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-8.png
// module id = 768
// module chunks = 0